<script setup>
  import { computed } from 'vue'

  import {
    fieldCommonProps,
    getTooltipText,
  } from '@/features/settingsManagement/fieldManagement/edit/utils/fieldUtils.js'

  const props = defineProps({
    field: fieldCommonProps.field,
    externalRequired: fieldCommonProps.externalRequired,
  })

  const externalRequired = computed(() => props.externalRequired)
  const extraDataTooltip = computed(() => getTooltipText(props))
</script>

<template>
  <label>
    {{ field.key }}
    <span v-if="externalRequired" class="text-required">*</span>

    <span class="tooltip-wrap">
      <i v-if="extraDataTooltip" v-tooltip.top="extraDataTooltip" class="pi pi-info-circle"></i>
    </span>
  </label>
</template>

<style lang="scss" scoped>
  label {
    font-weight: bold;
    display: flex;
    align-items: center;
  }
  .text-required {
    color: var(--fm-ui-red-color);
  }

  .tooltip-wrap {
    margin-left: auto;
  }
</style>
